import { useAppSelector } from 'hooks/redux';

// Single source of truth for the `newDesign` user flag (SBK-9080 redesign). Absent → false.
export const useIsNewDesign = (): boolean =>
  useAppSelector((state) => state.collection.collectionCreator?.featureFlags?.newDesign === true);
